/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateEvidenceImageRequest
 */
export interface UpdateEvidenceImageRequest {
    /**
     * 
     * @type {File}
     * @memberof UpdateEvidenceImageRequest
     */
    'file'?: File;
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceImageRequest
     */
    'electronicMethod'?: UpdateEvidenceImageRequestElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceImageRequest
     */
    'documentSize'?: UpdateEvidenceImageRequestDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateEvidenceImageRequest
     */
    'heightMillis'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateEvidenceImageRequest
     */
    'widthMillis'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceImageRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEvidenceImageRequest
     */
    'irrelevantToLedger'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEvidenceImageRequest
     */
    'dpiForciblyValid'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEvidenceImageRequest
     */
    'colorGradationForciblyValid'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEvidenceImageRequest
     */
    'uploadedByRecipient'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceImageRequest
     */
    'uploadedFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceImageRequest
     */
    'invoiceIssuerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceImageRequest
     */
    'invoiceIssuerRegistrationNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEvidenceImageRequest
     */
    'asQualified'?: boolean | null;
}

export const UpdateEvidenceImageRequestElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type UpdateEvidenceImageRequestElectronicMethodEnum = typeof UpdateEvidenceImageRequestElectronicMethodEnum[keyof typeof UpdateEvidenceImageRequestElectronicMethodEnum];
export const UpdateEvidenceImageRequestDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type UpdateEvidenceImageRequestDocumentSizeEnum = typeof UpdateEvidenceImageRequestDocumentSizeEnum[keyof typeof UpdateEvidenceImageRequestDocumentSizeEnum];


